import React, { useEffect, useState } from 'react'
import styles from "./styles.module.css"
import { ChakraProvider, Input, Select, Spinner, Switch, Text, extendTheme } from '@chakra-ui/react'
import { Button } from 'antd'
import { message } from 'antd'
import { userRequest } from '../../requestMethod'
import ActivePlan from './ActivePlan/ActivePlan'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import amazone from "../../assets/for_this/amazonPay1.png"
import payPal from "../../assets/for_this/payPal1.png"
import klarna from "../../assets/for_this/klarna1.png"
import arrowIcon from "../../assets/black arrow.png"
const initialState = {
    old: "",
    new: "",
    confirm: "",

}
const initialStateEmail = {

    oldEmail: "",
    newEmail: ""


}
const initialStatePayment = {

    cardNumber: "",
    expireAt: "",
    cvv: "",
    postalCode: "",
    method: ["Amazon"]


}
const Settings = () => {
    const [user, setUser] = useState({})
    const [loading, setLoading] = useState(false)
    const [loading1, setLoading1] = useState(false)
    const [form, setForm] = useState(initialState)
    const [email, setEmail] = useState(initialStateEmail)
    const [state, setState] = useState("reset")
    const [paymentMethod, setPaymentMethod] = useState(initialStatePayment)
    const [selectedDate, setSelectedDate] = useState(null);

    const handleChange = (date) => {
        setSelectedDate(date);
    };

    const setPassword = () => {
        if (!form.old) {
            message.error("Old Password is required")
        }
        else {
            if (!form.new) {
                message.error("New Password is required")
            }
            else {
                if (!form.confirm) {
                    message.error("Confirm Password is required")
                }
                else {
                    if (form.new !== form.confirm) {
                        message.error("Password Mismatch")
                    } else {
                        userRequest.put('/partner/user/updatePassword', { oldPassword: form.old, newPassword: form.new }).then(() => {
                            message.success("Password Updated")
                            setForm(initialState)
                        }).catch((error) => {
                            console.log('error:', error)

                            message.error(error?.response?.data?.message)
                        })
                    }
                }
            }


        }


    }

    const getPaymentMethod = () => {
        userRequest.get("/partner/user/getPaymentDetails").then((res) => {
            setPaymentMethod(res.data.data)
            setState("payment")
            return res.data.data
        }).catch((err) => {
            message.error("Something went wrong")

        })
    }

    const updatePaymentMethod = () => {
        userRequest.put("partner/user/updatePaymentDetails", paymentMethod).then((res) => {
            // setPaymentMethod(res.data.data)
            message.success("Payment method updated successfully")
            return res.data.data
        })
    }
    const handleCvvChange = (e) => {
        // Ensure the input value does not exceed 4 characters
        if (e.target.value.length <= 4) {
            setPaymentMethod({ ...paymentMethod, cvv: e.target.value });
        }
    };

    const updateEmail = () => {
        if (!email.oldEmail) {
            message.error("Old email is required")
        } else {
            if (!email.newEmail) {
                message.error("New email is required")
            } else {
                userRequest.put('/partner/user/updateEmail', email).then(() => {
                    message.success("Email Updated")
                    setEmail(initialStateEmail)
                }).catch((error) => {
                    console.log('error:', error)

                    message.error(error?.response?.data?.message)
                })

            }
        }
    }
    const customTheme = extendTheme({
        colors: {
            aqua: {
                50: "#e0f7fa",
                100: "#b3e7f7",
                200: "#81d6f5",
                300: "#4fc4f2",
                400: "#26b1ee",
                500: "#00a2e8", // Your custom "aqua" color
                600: "#0092d1",
                700: "#0080b8",
                800: "#006ea0",
                900: "#00598c",
            },
        },
    });


    const getUser = () => {
        userRequest.get("/partner/user/getUser").then((res) => {
            setUser(res.data.user[0])
            setLoading(false)
            setLoading1(false)



        })
    }
    useEffect(() => {
        getUser()
    }, [])
    return (
        <div className={styles.mainContainer}>
            <h1>Settings</h1>
            <div className={styles.container}>
                <div>
                    <div className={styles.toggle} id={state === "reset" && styles.active} onClick={() => setState("reset")}>
                        <p >Change Password</p>
                    </div>
                    <div className={styles.toggle}>
                        <p>Website Panel Notification</p>
                        <ChakraProvider theme={customTheme}>
                            {
                                loading ? <Spinner /> : <Switch colorScheme="aqua" isChecked={user?.isWebsiteNotification} onChange={() => {
                                    setLoading(true)
                                    userRequest.put(`/partner/user/updateUser`, { isWebsiteNotification: !user?.isWebsiteNotification }).then(() => {
                                        getUser()
                                    })
                                }} />
                            }
                        </ChakraProvider>
                    </div>
                    <div className={styles.toggle}>
                        <p>Email Notification</p>
                        <ChakraProvider theme={customTheme}>
                            {
                                loading1 ? <Spinner /> : <Switch colorScheme="aqua" isChecked={user?.isEmailNotification} onChange={() => {
                                    setLoading1(true)
                                    userRequest.put(`/partner/user/updateUser`, { isEmailNotification: !user?.isEmailNotification }).then(() => {
                                        getUser()
                                    })
                                }} />
                            }
                        </ChakraProvider>
                    </div>
                    <div className={styles.toggle} id={state === "plan" && styles.active} onClick={() => setState("plan")}>
                        <p value="">My Active Plan</p>
                        <img src={arrowIcon} alt="arrow missing" />
                    </div>
                    <div className={styles.toggle} id={state === "email" && styles.active} onClick={() => setState("email")}>
                        <p value="">Change Email ID</p>
                        <img src={arrowIcon} alt="arrow missing" />
                    </div>
                    <div className={styles.toggle} id={state === "payment" && styles.active} onClick={() =>setState("payment")}>
                    {/* {
                        getPaymentMethod()
                    } */}
                        <p value="">Change Payment Details</p>
                        <img src={arrowIcon} alt="arrow missing" />
                    </div>

                </div>
                <div className={state === "plan" ? styles.password : styles.resetPassword}>
                    {
                        state === "reset" &&
                        <>
                            <p>Old Password</p>
                            <Input placeholder='Enter Old Password' type='password' onChange={(e) => setForm({ ...form, old: e.target.value })} value={form.old} />
                            <p>New Password</p>
                            <Input placeholder='Enter new Password' type='password' onChange={(e) => setForm({ ...form, new: e.target.value })} value={form.new} />
                            <p>Confirm Password</p>
                            <Input placeholder='Confirm Your Password' type='password' onChange={(e) => setForm({ ...form, confirm: e.target.value })} value={form.confirm} />
                            <Button id={styles.submit} onClick={setPassword}>Submit</Button>
                        </>
                    }
                    {
                        state === "email" &&
                        <>
                            <p>Old Email ID*</p>
                            <Input placeholder='Enter Old Email id' type='email' onChange={(e) => setEmail({ ...email, oldEmail: e.target.value })} value={email.oldEmail} />
                            <p>New Email ID*</p>
                            <Input placeholder='Enter New Email id' type='email' onChange={(e) => setEmail({ ...email, newEmail: e.target.value })} value={email.newEmail} />
                            <Button id={styles.submit} onClick={updateEmail}>Save Changes</Button>
                        </>
                    }
                    {
                        state === "payment" &&
                        <div div className={styles.paymentPlanOne}>
                            <p>Card Number*</p>
                            <Input className={styles.cardInput} placeholder='Enter Card Number' type='number' onChange={(e) => setPaymentMethod({ ...paymentMethod, cardNumber: e.target.value })} value={paymentMethod.cardNumber} />
                            <div className={styles.innerPayment}>
                                <span >
                                    <label for="expiry">Expire Date (MM/YY)*</label>
                                    <DatePicker
                                        selected={selectedDate}
                                        onChange={handleChange}
                                        dateFormat="MM/yy"
                                        showMonthYearPicker
                                        isClearable
                                        className={styles.monthStyles}
                                        placeholderText="MM/YY"
                                    />

                                </span>
                                <span>
                                    <label>CVV (4 Digit)*</label>
                                    <Input maxLength={4} type='number' placeholder='CVV' onChange={handleCvvChange} value={paymentMethod.cvv} />
                                </span>


                            </div>
                            <p>Postal Code*</p>

                            <Input className={styles.postalInput} placeholder='Enter Postal Code' type='number' onChange={(e) => setPaymentMethod({ ...paymentMethod, postalCode: e.target.value })} value={paymentMethod.postalCode} />
                            <div className={styles.payMentMethod}>
                                <div className={styles.innerPaymentOne}>
                                    <input type="radio"   />
                                    <p>Amazon pay</p>
                                </div>
                                <img src={amazone} alt="" />
                            </div>

                            <div className={styles.payMentMethod}>
                                <div className={styles.innerPaymentOne}>
                                    <input type="radio" defaultChecked />
                                    <p>Paypal</p>
                                </div>
                                <img src={payPal} alt="" />
                            </div>

                            <div className={styles.payMentMethod}>
                                <div className={styles.innerPaymentOne}>
                                    <input type="radio"   />
                                    <p>Klarna</p>
                                </div>
                                <img src={klarna} alt="" />
                            </div>

                            <Button id={styles.submitOne} onClick={updatePaymentMethod}>Save Changes</Button>
                        </div>
                    }
                    {
                        state === "plan" && <ActivePlan />

                    }
                </div>
            </div>
        </div>
    )
}

export default Settings